import { useEffect, useState } from "react";
import { Button } from "../../../core/components/ui/button";
import { Icon } from "../../../core/components/ui/icon";
import { Modal } from "../../../core/components/ui/modal";
import { useToastStore } from "../../../core/stores/toast";
import { installPrompt, isInstalled } from "../../../pwa";

/**
 * « Installer l'application » : PROTECTO s'ouvre alors dans sa propre fenêtre,
 * sans barre d'adresse, avec son icône au Dock ou sur l'écran d'accueil.
 *
 * Chrome et Edge laissent déclencher l'installation depuis un bouton (voir
 * `installPrompt`). Safari ne le permet pas : on y explique le geste en deux
 * lignes plutôt que de faire semblant. Le bouton disparaît une fois
 * l'application installée.
 */
export function InstallButton() {
  const push = useToastStore((s) => s.push);
  const [available, setAvailable] = useState(false);
  const [installed, setInstalled] = useState(() => isInstalled());
  const [helping, setHelping] = useState(false);

  useEffect(() => installPrompt.subscribe(setAvailable), []);
  useEffect(() => {
    const media = window.matchMedia("(display-mode: standalone)");
    const sync = () => setInstalled(isInstalled());
    media.addEventListener("change", sync);
    return () => media.removeEventListener("change", sync);
  }, []);

  if (installed) return null;

  const install = async () => {
    if (await installPrompt.show()) {
      push("success", "Application installée", "Elle s'ouvre maintenant depuis votre bureau.");
      setInstalled(true);
    }
  };

  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        className="atelier-topbar__install"
        icon={<Icon name="arrow-down" size={16} />}
        title="Installer PROTECTO comme une application"
        onClick={() => (available ? void install() : setHelping(true))}
      >
        Installer l'app
      </Button>

      <Modal
        open={helping}
        title="Installer PROTECTO"
        onClose={() => setHelping(false)}
        footer={
          <Button variant="primary" onClick={() => setHelping(false)}>
            Compris
          </Button>
        }
      >
        <p>Votre navigateur n'ouvre pas l'installation depuis un bouton. Le geste reste simple :</p>
        <ul className="install-help">
          <li>
            <strong>iPad, iPhone (Safari)</strong> : bouton <em>Partager</em>, puis{" "}
            <em>Sur l'écran d'accueil</em>.
          </li>
          <li>
            <strong>Mac (Safari)</strong> : menu <em>Fichier</em>, puis <em>Ajouter au Dock</em>.
          </li>
          <li>
            <strong>Chrome, Edge</strong> : icône d'installation à droite de la barre d'adresse.
          </li>
        </ul>
        <p>
          L'application s'ouvre ensuite en plein écran, avec son icône — les données restent les
          mêmes.
        </p>
      </Modal>
    </>
  );
}
